<template>
  <div class="smart">
    <!-- banner部分 -->
    <div class="smart-banner clearfix">
      <div>
        <h2>智慧社区</h2>
        <h3>校园电子围栏系统</h3>
      </div>
    </div>
    <!-- 方案概述 -->
    <div class="container clearfix">
      <div class="smart-title">方案概述</div>
      <div class="smart-overview mb100">
        <div>
          <h2>校园电子围栏系统</h2>
          <p>
            系统主要以RFID电子学生证为载体，运用物联网技术实现对 校园的智能化管理，涉及内容包括智能考勤系统、区域定位系 统和综合管理系统。智能考勤系统功能包括：人员出入管 理、人员校内管理等；区域定位系统功能包括：、资产管 理、危险区域闯入预警管理、各功能区域管理、人员运动 行为轨迹查询与管理等；综合管理系统需采用物联网共性
            平台技术对以上各子系统综合管理，实现各类物联网应用 与联动，为学校教育、教学工作提供智慧化管理手段，建 立起“平安校园 绿色教室”的应用示范标准。同时系统留 有接口，满足学校未来管理需求。
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SscampuselEctronicfence',
};
</script>
<style scoped>
.smart-banner {
  width: 100%;
  height: 594px;
  background: #000;
}
.smart-banner div {
  overflow: hidden;
  width: 100%;
  height: 100%;
  background: url(../../../assets/img/smart/background_Image.png) no-repeat;
  background-size: cover;
}
.smart-banner h2 {
  margin-top: 182px;
  text-align: center;
  font-size: 100px;
  font-weight: bold;
  color: #fff;
}
.smart-banner h3 {
  text-align: center;
  font-size: 30px;
  font-weight: 400;
  color: #fff;
}
.smart-title {
  width: 100%;
  margin-top: 100px;
  margin-bottom: 100px;
  text-align: center;
  font-size: 60px;
  font-weight: bold;
  color: #000;
}
.smart-overview {
  width: 100%;
  height: 334px;
}
.smart-overview {
  width: 100%;
  height: 334px;
}
.smart-overview p {
  font-size: 18px;
  font-weight: 400;
  color: #666;
  text-indent: 2em;
  line-height: 1.8;
}
.smart-overview h2 {
  text-align: center;
  margin-bottom: 45px;
  font-size: 24px;
  font-weight: bold;
  color: #000;
}
</style>
